module.exports = __webpack_public_path__ + "img/Transverse Cracking_high severity.f68ff053.jpg";